export default "__VITE_ASSET__BJtIUcdS__"